export const CorrectionType = {
	pallet_correction: 1,
};
